
import React from 'react';

export const BasicConfigTab = () => {
  return (
    <div className="space-y-4">
      <p className="text-muted-foreground">
        Configure basic application deployment settings.
      </p>
      
      <div className="p-4 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-800">
        Application basic configuration settings will be implemented in a future update.
      </div>
    </div>
  );
};
